import { Layout } from "@mcleod/components";
import { AutogenLayoutAdvancedSearch } from "./autogen/AutogenLayoutAdvancedSearch";
import { TableCustomerOrders } from "./TableCustomerOrders";
export class AdvancedSearch extends AutogenLayoutAdvancedSearch {
  override async onLoad(): Promise<void> {
    this.switchDate.checked = true;
    this.switchDate.checked = false;
    this.textboxStatus.selectedItem = this.textboxStatus.items[0];
    this.textboxShipDateTo.visible = false;
    this.location.webLocationsOnly = true;
    this.location.textCombined.manualAddLayout = null;
    this.switchDate.addChangeListener(event => {
      if (event.newValue) {
        this.textboxShipDateTo.visible = true;
      } else {
        this.textboxShipDateTo.visible = false;
        this.textboxShipDateTo.text = "";
      }
    });
    const layout = Layout.getLayout("portal-customer/TableCustomerOrders", {id: "layoutTableCustomerOrders"}) as TableCustomerOrders;
    return new Promise((resolve) => {
      layout.addLayoutLoadListener(() => {
        this.replaceMainDatasource(layout.mainDataSource);
        this.add(layout);
        this.panelSearch.forEveryChildComponent(comp => {
          if (comp.dataSource != null)
            comp.dataSource = layout.mainDataSource;
        })
        return resolve();
      });
    });
  }
}
